import { Component, OnInit, EventEmitter, ChangeDetectorRef, Inject } from '@angular/core';
import { latLng, tileLayer, icon, marker } from 'leaflet';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'bt-location-selector',
  templateUrl: './location-selector.component.html',
  styleUrls: ['./location-selector.component.scss']
})
export class LocationSelectorComponent implements OnInit {
  layers = [];
  selectedLocation;
  options;

  constructor(
    public cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.setOptionMap();
    }, 10);
  }

  saveLocation() {

  }

  setOptionMap() {
    this.options = {
      layers: [
        tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: 'www.brandtarinha.com',
        })],
      zoom: 17,
      center: latLng([this.data ? this.data.lat : 36.2605, this.data ? this.data.lng : 59.6168]),
    };
    this.cd.detectChanges();
    if (this.data) {
      this.leafletClick({
        latlng: this.data,
      });
    }
  }

  leafletClick(event) {
    this.layers = [];
    this.selectedLocation = [String(event.latlng.lat), String(event.latlng.lng)];
    this.layers.push(
      marker([event.latlng.lat, event.latlng.lng], {
        icon: icon({
          iconSize: [41, 45],
          // iconAnchor: [13, 41],
          iconUrl: 'assets/pin-delete-1.svg',
          // shadowUrl: 'assets/icons/map/pin-star.svg'
        })
      })
    );
  }
}
